export default "__VITE_ASSET__uIksYR0E__"